<template>
    <header-button-app>
        <li v-if="showMenuWishlist">
            <MenuWishlist
                :routewishlist="routewishlist"
                display="block"
                displayMedia="none"
            />
        </li>
        <li class="register-link" v-if="company.finalizacao_pagamento.tipo != 'ORCAMENTO'">
            <MenuMyAccount
                :side_left="side_left"
                :show_minha_conta="show_minha_conta"
                :client_logged="client_logged"
                :company="company"
                :routeminhaconta="routeminhaconta"
                :routewishlist="routewishlist"
                :routepurchases="routepurchases"
            />
            <!-- <content-login-account>
                <a :href="!client ? $baseUrl+'login' : '#'" :style="`font-size: ${show_minha_conta == true ? '10px': '0px'};`">
                    <span>{{ show_minha_conta == true ? 'Minha Conta' : '' }}</span>
                </a>
                <nav-login-app v-if="client" :sideLeft="side_left">
                    <nav-brand-app top="25px">
                        <nav-link-app><a :href="routeminhaconta" class="">Minha Conta</a></nav-link-app>
                        <nav-link-app><a :href="routewishlist" class="">Lista de desejos</a></nav-link-app>
                        <nav-link-app><a :href="routepurchases" class="">Meus pedidos</a></nav-link-app>
                        <nav-link-app><a @click.prevent="logout()" href="#" class="">Sair</a></nav-link-app>

                    </nav-brand-app>
                </nav-login-app>
            </content-login-account> -->
        </li>
        <template v-if="company.finalizacao_pagamento.tipo == 'ORCAMENTO' && socials">
            <template v-for="(social, key) in socials">
                <li v-if="social.link && social.settings.header_menu == true" :key="key">
                    <iconmenu>
                        <a
                            :href="social.link"
                            target="_blank"
                            :aria-label="social.title"
                        >
                            <i :class="social.icone" :title="social.title"></i>
                        </a>
                    </iconmenu>
                </li>
            </template>
        </template>
        <li :style="company.finalizacao_pagamento.tipo == 'ORCAMENTO' ? 'margin-left:12px;' : null">
            <DropDownCart
                :cart_left="cart_left"
                :show_code_original_beside_description="show_code_original"
            />
        </li>
    </header-button-app>
</template>

<script>
import {
    CHeaderButton,
    CNavbarDrop,
    CNavbarLoginDrop,
    CNavBrand,
    CNavbarLink,
    CContentLoginAccount
} from '../Styles/Header/styled'
import {
    CDropdownCart,
    CDropdownMenu,
    CDropdownCartHeader,
    CDropdownMenuWrapper,
} from '../Styles/Dropdown/styled'
import {mapActions, mapState} from 'vuex'
import {CAncora} from '../../components/Styles/Button/styled'
import DropDownCart from '../cart/DropDownCart.vue'
import MenuMyAccount from './MenuMyAccount.vue'
import MenuWishlist from './MenuWishlist.vue'

export default {
    name:'Menu',
    components: {
        'header-button-app': CHeaderButton,
        'nav-drop-app': CNavbarDrop,
        'nav-login-app': CNavbarLoginDrop,
        'nav-brand-app': CNavBrand,
        'nav-link-app': CNavbarLink,
        'c-ancora': CAncora,
        'dropdown-cart' : CDropdownCart,
        'dropdown-menu': CDropdownMenu,
        'dropdown-menu-wrapper' : CDropdownMenuWrapper,
        'dropdown-cart-header' : CDropdownCartHeader,
        'content-login-account': CContentLoginAccount,
        DropDownCart,
        MenuMyAccount,
        MenuWishlist,
    },
    props: {
        client_logged: {
            default: null
        },
        company: {
            default: null
        },
        routeminhaconta: {
            default: null
        },
        routewishlist: {
            default:null
        },
        routepurchases: {
            default:null
        },
        socials: {
            default: []
        },
        show_code_original: {
            default: false
        },
        cart_left: {
            default: false
        },
        side_left: {
            default: false
        },
        show_minha_conta: {
            default: true
        }
    },
    async mounted() {
         this.ActionSetSocials(this.socials)
        this.ActionSetCompany(this.company)
        // if (!this.client_logged.logged) {
        //     this.ActionSetClient(null)
        //     return
        // }
        // this.ActionSetClient(this.client_logged.data)
    },
    methods: {
        ...mapActions("company", [
            "ActionSetSocials",
            "ActionSetCompany"
        ]),
        // ...mapActions("clients", [
        //     "ActionSetClient",
        //     "ActionLogout"
        // ]),
        // async logout() {
        //     await this.ActionLogout()
        //     .then(response => {})
        //     .catch(error => {})
        //     window.location.href = this.$baseUrl
        // }
    },
    computed: {
        // ...mapState("clients", [
        //     "client"
        // ]),
        showMenuWishlist() {
            return this.$root.$children[0].theme?.header?.active_icon_wishlist ?? false
        }
    }
}
</script>
